module.exports = __webpack_public_path__ + "static/media/use_graph01_eng.9a5d5803.jpg";